"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.velocityPage = velocityPage;
const uom_1 = require("@genesys/uom");
function velocityPage(coilType, si) {
    if (coilType === "fluid-cooling" || coilType === "fluid-heating") {
        return fluidVelocityPage(coilType === "fluid-cooling", si);
    }
    else {
        return standardVelocityPage(coilType === "dx", si);
    }
}
function interval(start, step, steps) {
    return new Array(steps)
        .fill(0)
        .map((_v, ix) => uom_1.Amount.plus(start, uom_1.Amount.times(step, ix)));
}
function standardVelocityPage(cooling, si) {
    const velocities = interval(uom_1.Amount.create(1.5, uom_1.Units.MeterPerSecond), uom_1.Amount.create(0.5, uom_1.Units.MeterPerSecond), 5);
    const powers = interval(uom_1.Amount.create(100, uom_1.Units.KiloWatt), uom_1.Amount.create(0, uom_1.Units.KiloWatt), 5);
    const pressures = interval(uom_1.Amount.create(20, uom_1.Units.Pascal), uom_1.Amount.create(5, uom_1.Units.Pascal), 5);
    const velocityUnit = si ? uom_1.Units.MeterPerSecond : uom_1.Units.FeetPerMinute;
    const powerUnit = si ? uom_1.Units.KiloWatt : uom_1.Units.HorsePower;
    const pressureUnit = si ? uom_1.Units.Pascal : uom_1.Units.InchOfWaterColumn;
    const unitStr = (unit) => `[${uom_1.Serialize.unitToString(unit)}]`;
    const velValue = (amount) => {
        const format = uom_1.Format.getUnitFormat(velocityUnit);
        return uom_1.Amount.valueAs(velocityUnit, amount).toFixed(format.decimalCount);
    };
    const powerValue = (amount) => {
        const format = uom_1.Format.getUnitFormat(powerUnit);
        return uom_1.Amount.valueAs(powerUnit, amount).toFixed(format.decimalCount);
    };
    const pressureValue = (amount) => {
        const format = uom_1.Format.getUnitFormat(pressureUnit);
        return uom_1.Amount.valueAs(pressureUnit, amount).toFixed(format.decimalCount);
    };
    const units = [unitStr(velocityUnit), unitStr(powerUnit)]
        .concat([unitStr(pressureUnit)])
        .concat(cooling ? [unitStr(powerUnit)].concat(unitStr(pressureUnit)) : []);
    const headers = ["Air velocity", "Dry total power"]
        .concat(["Dry pressure drop"])
        .concat(cooling
        ? ["Dry + Wet total power"].concat(["Dry + wet pressure drop"])
        : []);
    const rows = velocities.map((v, ix) => [velValue(v), powerValue(powers[ix])]
        .concat([pressureValue(pressures[ix])])
        .concat(cooling
        ? [powerValue(powers[ix])].concat([pressureValue(pressures[ix])])
        : []));
    const space = ["", ""]
        .concat([""])
        .concat(cooling ? [""].concat([""]) : []);
    const velocityBlocks = [...rows, space, ...rows];
    return [units, headers, ...velocityBlocks];
}
function fluidVelocityPage(cooling, si) {
    const airFlows = interval(uom_1.Amount.create(2000, uom_1.Units.StandardCubicMeterPerHour), uom_1.Amount.create(1000, uom_1.Units.StandardCubicMeterPerHour), 5);
    const airPressures = interval(uom_1.Amount.create(101325, uom_1.Units.Pascal), uom_1.Amount.create(0, uom_1.Units.Pascal), 5);
    const temperatures = interval(uom_1.Amount.create(20, uom_1.Units.Celsius), uom_1.Amount.create(0, uom_1.Units.Celsius), 5);
    const airHumidities = interval(uom_1.Amount.create(8, uom_1.Units.GramPerKilogram), uom_1.Amount.create(0, uom_1.Units.GramPerKilogram), 5);
    const volumeFlows = interval(uom_1.Amount.create(1000, uom_1.Units.LiterPerHour), uom_1.Amount.create(200, uom_1.Units.LiterPerHour), 5);
    const powers = interval(uom_1.Amount.create(100, uom_1.Units.KiloWatt), uom_1.Amount.create(0, uom_1.Units.KiloWatt), 5);
    const pressures = interval(uom_1.Amount.create(20, uom_1.Units.Pascal), uom_1.Amount.create(5, uom_1.Units.Pascal), 5);
    const weights = interval(uom_1.Amount.create(1, uom_1.Units.One), uom_1.Amount.create(0, uom_1.Units.One), 5);
    const airFlowUnit = si
        ? uom_1.Units.StandardCubicMeterPerHour
        : uom_1.Units.StandardCubicFeetPerMinute;
    const temperatureUnit = si ? uom_1.Units.Celsius : uom_1.Units.Fahrenheit;
    const humidityUnit = si ? uom_1.Units.GramPerKilogram : uom_1.Units.GrainPerPoundLb;
    const powerUnit = si ? uom_1.Units.KiloWatt : uom_1.Units.HorsePower;
    const pressureUnit = si ? uom_1.Units.Pascal : uom_1.Units.InchOfWaterColumn;
    const volumeFlowUnit = si ? uom_1.Units.LiterPerSecond : uom_1.Units.GallonsPerMinute;
    const weightsUnit = uom_1.Units.One;
    const unitStr = (unit) => `[${uom_1.Serialize.unitToString(unit)}]`;
    const massFlowValue = (amount) => {
        const format = uom_1.Format.getUnitFormat(airFlowUnit);
        return uom_1.Amount.valueAs(airFlowUnit, amount).toFixed(format.decimalCount);
    };
    const temperatureValue = (amount) => {
        const format = uom_1.Format.getUnitFormat(temperatureUnit);
        return uom_1.Amount.valueAs(temperatureUnit, amount).toFixed(format.decimalCount);
    };
    const humidityValue = (amount) => {
        const format = uom_1.Format.getUnitFormat(humidityUnit);
        return uom_1.Amount.valueAs(humidityUnit, amount).toFixed(format.decimalCount);
    };
    const powerValue = (amount) => {
        const format = uom_1.Format.getUnitFormat(powerUnit);
        return uom_1.Amount.valueAs(powerUnit, amount).toFixed(format.decimalCount);
    };
    const pressureValue = (amount) => {
        const format = uom_1.Format.getUnitFormat(pressureUnit);
        return uom_1.Amount.valueAs(pressureUnit, amount).toFixed(format.decimalCount);
    };
    const volumeFlowValue = (amount) => {
        const format = uom_1.Format.getUnitFormat(volumeFlowUnit);
        return uom_1.Amount.valueAs(volumeFlowUnit, amount).toFixed(format.decimalCount);
    };
    const weightsValue = (amount) => {
        const format = uom_1.Format.getUnitFormat(weightsUnit);
        return uom_1.Amount.valueAs(weightsUnit, amount).toFixed(format.decimalCount);
    };
    const units = [unitStr(airFlowUnit), unitStr(pressureUnit)]
        .concat([unitStr(temperatureUnit), unitStr(humidityUnit)])
        .concat([unitStr(temperatureUnit), unitStr(volumeFlowUnit)])
        .concat([unitStr(weightsUnit), unitStr(powerUnit)])
        .concat([unitStr(weightsUnit), unitStr(pressureUnit)])
        .concat(cooling
        ? [unitStr(temperatureUnit), unitStr(humidityUnit)]
            .concat([unitStr(temperatureUnit), unitStr(volumeFlowUnit)])
            .concat(unitStr(weightsUnit), [unitStr(powerUnit)])
            .concat(unitStr(weightsUnit), [unitStr(powerUnit)])
            .concat(unitStr(weightsUnit), [unitStr(pressureUnit)])
        : []);
    const headers = ["Air flow", "Air pressure in"]
        .concat(["Dry air temperature in", "Dry air humidity in"])
        .concat(["Dry fluid temperature in", "Dry fluid flow"])
        .concat(["Dry weight total power", "Dry total power"])
        .concat(["Dry weight pressure drop", "Dry pressure drop"])
        .concat(cooling
        ? ["Dry + Wet air temperature in", "Dry + Wet air humidity in"]
            .concat(["Dry + Wet fluid temperature in", "Dry + wet fluid  flow"])
            .concat(["Dry + Wet weight total power", "Dry + Wet total power"])
            .concat([
            "Dry + Wet weight sensible power",
            "Dry + Wet sensible power"
        ])
            .concat([
            "Dry + wet weight pressure drop",
            "Dry + wet pressure drop"
        ])
        : []);
    const rows = airFlows.map((v, ix) => [massFlowValue(v), pressureValue(airPressures[ix])]
        .concat([
        temperatureValue(temperatures[ix]),
        humidityValue(airHumidities[ix])
    ])
        .concat([
        temperatureValue(temperatures[ix]),
        volumeFlowValue(volumeFlows[ix])
    ])
        .concat([weightsValue(weights[ix]), powerValue(powers[ix])])
        .concat([weightsValue(weights[ix]), pressureValue(pressures[ix])])
        .concat(cooling
        ? [
            temperatureValue(temperatures[ix]),
            humidityValue(airHumidities[ix])
        ]
            .concat([
            temperatureValue(temperatures[ix]),
            volumeFlowValue(volumeFlows[ix])
        ])
            .concat([weightsValue(weights[ix]), powerValue(powers[ix])])
            .concat([weightsValue(weights[ix]), powerValue(powers[ix])])
            .concat([weightsValue(weights[ix]), pressureValue(pressures[ix])])
        : []));
    const space = ["", ""]
        .concat(["", ""])
        .concat(["", ""])
        .concat(["", ""])
        .concat(["", ""])
        .concat(cooling ? ["", ""].concat(["", ""]).concat(["", ""]).concat(["", ""]) : []);
    const velocityBlocks = [...rows, space, ...rows];
    return [units, headers, ...velocityBlocks];
}
//# sourceMappingURL=velocity-page.js.map